import React from "react";
import { PanelRow } from "@wordpress/components";

const PremiumText = ({ isPremium }) => {
  return isPremium ? (
    <></>
  ) : (
    <PanelRow>
      <p className="text-danger">Premium Feature</p>
    </PanelRow>
  );
};

export default PremiumText;
